import Vue from 'vue'

Vue.prototype.$availableOrderType = {
  tailored: [
    {
      key: 'B1',
      variant: [
        {
          key: 'firstOrder',
          variant: [
            {
              key: 'measurements',
              variant: [{ key: 'card' }, { key: 'card2' }],
            },
            {
              key: 'last',
              variant: [
                {
                  key: 'formplusplant',
                  variant: [{ key: 'mod' }, { key: 'nomod' }, { key: 'file3D' }],
                },
              ],
            },
          ],
        },
        {
          key: 'relatedOrder',
          variant: [
            { key: 'toFinish' },
            {
              key: 'toModify',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'rif' }],
            },
            {
              key: 'comeBack',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }, { key: 'rif' }],
            },
            {
              key: 'notCompliant',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }],
            },
          ],
        },
      ],
    },
    {
      key: 'B2',
      variant: [
        {
          key: 'firstOrder',
          variant: [
            {
              key: 'measurements',
              variant: [{ key: 'card2' }],
            },
            {
              key: 'digitalMeasurements',
              variant: [{ key: 'formproj' }],
            },
            {
              key: 'last',
              variant: [
                { key: 'modify' },
                {
                  key: 'formplusplant',
                  variant: [{ key: 'nomod' }, { key: 'mod' }, { key: 'file3D' }],
                },
                {
                  key: 'form',
                  variant: [{ key: 'nomod' }, { key: 'mod' }, { key: 'file3D' }],
                },
              ],
            },
          ],
        },
        {
          key: 'relatedOrder',
          variant: [
            { key: 'toFinish' },
            {
              key: 'toModify',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'rif' }],
            },
            {
              key: 'ToModifyafter',
              variant: [{ key: 'y' }, { key: 'n' }],
            },
            {
              key: 'comeBack',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }, { key: 'rif' }],
            },
            {
              key: 'notCompliant',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }],
            },
          ],
        },
      ],
    },
    {
      key: 'B3',
      variant: [
        {
          key: 'firstOrder',
          variant: [
            {
              key: 'measurements',
              variant: [{ key: 'card' }],
            },
            {
              key: 'digitalMeasurements',
              variant: [{ key: 'cardplusddd' }],
            },
            {
              key: 'last',
              variant: [
                { key: 'modify' },
                {
                  key: 'formplusplant',
                  variant: [{ key: 'mod' }],
                },
                {
                  key: 'form',
                  variant: [{ key: 'mod' }],
                },
              ],
            },
          ],
        },
        {
          key: 'relatedOrder',
          variant: [
            { key: 'toFinish' },
            {
              key: 'toModify',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'rif' }],
            },
            {
              key: 'comeBack',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }, { key: 'rif' }],
            },
            {
              key: 'notCompliant',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }],
            },
          ],
        },
      ],
    },
    {
      key: 'B4',
      variant: [
        {
          key: 'firstOrder',
          variant: [
            {
              key: 'measurements',
              variant: [{ key: 'card' }, { key: 'card2' }],
            },
            {
              key: 'digitalMeasurements',
              variant: [{ key: 'cardplusddd' }, { key: 'formproj' }],
            },
            {
              key: 'mold',
              variant: [
                {
                  key: 'negative',
                  variant: [{ key: 'bil' }, { key: 'mono' }],
                },
                {
                  key: 'positive',
                  variant: [{ key: 'bil' }, { key: 'mono' }],
                },
              ],
            },
            {
              key: 'last',
              variant: [
                { key: 'modify' },
                {
                  key: 'formplusplant',
                  variant: [{ key: 'nomod' }, { key: 'mod' }, { key: 'file3D' }],
                },
                {
                  key: 'form',
                  variant: [{ key: 'nomod' }, { key: 'mod' }, { key: 'file3D' }],
                },
                {
                  key: 'duneform',
                },
              ],
            },
          ],
        },
        {
          key: 'relatedOrder',
          variant: [
            { key: 'toFinish' },
            {
              key: 'toModify',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'rif' }],
            },
            {
              key: 'comeBack',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }, { key: 'rif' }],
            },
            {
              key: 'notCompliant',
              variant: [{ key: 'formpos' }, { key: 'tom' }, { key: 'rim' }, { key: 'fon' }],
            },
          ],
        },
      ],
    },
  ],
  fits: [
    {
      key: 'FITS',
      variant: [
        {
          key: 'firstOrder',
        },
      ],
    },
  ],
  modular: [
    {
      key: 'BM1',
      variant: [
        {
          key: 'firstOrder',
        },
      ],
    },
  ],
  insole: [
    {
      key: 'BI1',
      variant: [
        {
          key: 'firstOrder',
          variant: [
            {
              key: 'measurements',
              //for the moment i try without variants
            },
            {
              key: 'digitalmeasurements',
              //for the moment i try without variants
            },
            {
              key: 'negative',
              //for the moment i try without variants
            },
            {
              key: 'fenofoam',
              //for the moment i try without variants
            },
            {
              key: 'positiveormodified',
              //for the moment i try without variants
            },
          ],
        },
      ],
    },
  ],
}
